export default __webpack_public_path__ + "static/media/Kevin Khuu - Communications Associate.b9247c22.jpg";